import Vue from 'vue';

export function setPage(state, value) {
  state.page = value;
}
export function setAnswer(state, payload) {
  Vue.set(state.answers, payload.index, payload.updates);
}
export function saveReport(state, payload) {
  state.reportData = payload;
}
export function addReport(state, payload) {
  let copy = true;

  // Loop through all to check if it's already added
  Object.keys(state.reports).forEach(function (key) {
    if (state.reports[key].report_id == payload.report_id) {
      copy = false;
    }
  });

  if (copy) state.reports.push(payload);
}

export function newUser(state, payload) {
  let copy = true;

  // Loop through all to check if it's already added
  Object.keys(state.users_admin).forEach(function (key) {
    if (state.users_admin[key].user_id == payload.user_id) {
      copy = false;
    }
  });

  if (copy) {
    // @ts-ignore
    Object.assign(state.users_admin[key + 1], payload);
  }
}
export function updateUser(state, payload) {
  // Loop through all to check if it's already added
  Object.keys(state.users_admin).forEach(function (key) {
    if (state.users_admin[key].user_id == payload.user_id) {
      Object.assign(state.users_admin[key], payload);
    }
  });
}

export function createProfile(state, payload) {
  // @HOTFIX: move this to researchForm
  let years = payload.profile.year;
  try {
    years = JSON.parse(payload.profile.year);
    years.map((y) => parseInt(y));
  } catch (error) {
    years = parseInt(years);
  }
  payload.profile.year = years;
  state.profiles.push(payload.profile);
}

export function setSearch(state, value) {
  state.lastSearch = value;
}

export function setResponse(state, value) {
  state.response = value;
}
export function setFilteredResults(state, value) {
  state.filteredResults = value;
}
export function setProfile(state, value) {
  state.currentProfile = value;
}
export function setAllUsers(state, payload) {
  state.users_admin = payload;
}
export function setAllReports(state, payload) {
  state.reports_admin = payload;
}
export function updateReport(state, payload) {
  let allreports = state.reports_admin;

  Object.keys(allreports).forEach(function (id) {
    let report = allreports[id];
    if (report.report_id == payload.report_id) {
      Object.keys(report).forEach(function (field) {
        Object.keys(payload).forEach(function (update) {
          if (field == update) {
            report[field] = payload[update];
          }
        });
      });
    }
    allreports[id] = report;
  });
  state.reports_admin = allreports;
}

//@TODO: can be merged with setProfile({})
export function clearProfile(state, value) {
  state.currentProfile = {
    markets: [],
    years: null,
    demographics: {},
    behaviours: {},
    plannings: {},
    factors: {},
    catalysts: {},
    enablers: {},
    destinations: {},
    barriers: {},
    multiple: false,
    buyer: null,
    traveller: null
  };
}
export function deleteProfiles(state, value) {
  state.profiles = [];
  Object.assign(state.currentProfile, {
    markets: state.currentProfile.markets,
    demographics: {},
    behaviours: {},
    plannings: {},
    factors: {},
    catalysts: {},
    enablers: {},
    destinations: {},
    barriers: {}
  });
}

export function setProfiles(state, value) {
  state.profiles = value;
}

export function setRequestSearch(state, value) {
  state.requestSearch = value;
}

export function setAnswerMultia(state, payload) {
  let aux = {};
  let all = {};
  let ans = state.answers;
  const ang = ans[payload.index];

  if (!ang) {
    Object.assign(all, ang);
    Object.assign(aux, ang[payload.country]);
  }

  Vue.set(aux, payload.country, payload.answer);
  Object.assign(all[payload.group], aux);
  Vue.set(state.answers, payload.index, all);
}
export function setAnswerMulti(state, payload) {
  let aux = {};
  let all = {};

  // Get first existing data
  Object.assign(all, state.answers[payload.index]);
  Object.assign(aux, all[payload.group]);

  // Add new data
  Vue.set(aux, payload.country, payload.answer);
  Vue.set(all, payload.group, aux);
  Vue.set(state.answers, payload.index, all);
}
export function setQuestions(state, questions) {
  Object.assign(state.questions, questions);
}

export function setReport(state, value) {
  state.reportSelected = value;
}

export function deleteReports(state, value) {
  state.reports = [];
}

export function setMenu(state, payload) {
  state.filterMenuSearch = payload;
}

export function setReportLoaded(state, payload) {
  state.reportLoaded = payload;
}

// export function setMultiple(state, payload) {
//   state.currentProfile.multiple = payload;
// }
// export function setBuyer(state, payload) {
//   state.currentProfile.buyer = payload;
// }
// export function setYears(state: IQuestionsState, payload) {
//   state.currentProfile.year = payload;
// }
// export function setMarkets(state: IQuestionsState, payload) {
//   state.currentProfile.market = payload;
// }
// export function setDemographics(state, payload) {
//   state.currentProfile.demographics = payload;
// }
// export function setBehaviours(state, payload) {
//   state.currentProfile.behaviours = payload;
// }
// export function setFactors(state, payload) {
//   state.currentProfile.factors = payload;
// }
// export function setCatalysts(state, payload) {
//   state.currentProfile.catalysts = payload;
// }
// export function setEnablers(state, payload) {
//   state.currentProfile.enablers = payload;
// }
// export function setBarriers(state, payload) {
//   state.currentProfile.barriers = payload;
// }
// export function setPlannings(state, payload) {
//   state.currentProfile.plannings = payload;
// }
// export function setDestinations(state, payload) {
//   state.currentProfile.destinations = payload;
// }
// export function setTraveller(state: IQuestionsState, payload) {
//   state.currentProfile.traveller = payload;
// }
